import { requst } from '../config'

// export const postUploadBatchApi = file => {
//     const url = `/map/border/uploadBatch`
//     const formData = new FormData()
//     formData.append('files', file)
//     return requst({
//         url,
//         method: 'post',
//         params: {
//             type: 'kml',
//         },
//         headers: {
//             'Content-Type': 'multipart/form-data',
//         },
//         data: formData,
//     })
// }

export const postZipperApi = (params, modalAddNew) => {
    const url = `/map/zipper`
    if (modalAddNew) {
        return requst.post(url, params)
    } else {
        return requst.put(url, params)
    }
}

export const getZipperListApi = projectId => {
    const url = `/map/zipper/list?projectId=${projectId}`
    return requst.get(url)
}

export const getZipperIdApi = id => {
    const url = `/map/zipper/${id}`
    return requst.get(url)
}


export const getZipperDeleteApi = id => {
    const url = `/map/zipper/${id}`
    return requst.delete(url)
}